<template>
  <div class='flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between'>
    <div>
      <div
        class='text-xs uppercase tracking-wide text-gray-500'
        :class='{ "text-green-700": isVerified }'
      >
        {{ methodType }}
      </div>
      <div
        class='text-sm font-semibold text-gray-900'
        :class='{ "text-green-800": isVerified }'
      >
        {{ resolvedMethodName }}
      </div>
    </div>
    <div
      v-if='showStatus'
      class='text-xs text-gray-500'
      :class='{ "text-green-700": isVerified }'
    >
      Status: <span class='font-semibold text-gray-800'>{{ resolvedStatus }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  const props = defineProps<{ methodType: string; methodName: string; isVerified: boolean; challengeStatus: string; showStatus: boolean }>()

  const methodTypeLower = computed(() => props.methodType.toLowerCase())
  const normalizedStatus = computed(() => props.challengeStatus?.toLowerCase() ?? '')

  const resolvedMethodName = computed(() => {
    if (props.methodName === 'totp') {
      return 'Insert code from your authenticator app'
    }

    return props.methodName || 'New verification method'
  })

  const resolvedStatus = computed(() => {
    if (methodTypeLower.value === 'totp' && normalizedStatus.value === 'sent') {
      return 'Waiting for code from authenticator app'
    }

    return props.challengeStatus || ''
  })

</script>
